module.exports = __webpack_public_path__ + "static/media/v26.9d86a64c.mp4";